import React from 'react';
import { usePermissions, Permission } from '../hooks/usePermissions';

interface PermissionGateProps {
  children: React.ReactNode;
  permission?: Permission;
  permissions?: Permission[];
  requireAll?: boolean;
  fallback?: React.ReactNode;
  mode?: 'hide' | 'disable';
}

const PermissionGate: React.FC<PermissionGateProps> = ({
  children,
  permission,
  permissions = [],
  requireAll = false,
  fallback = null,
  mode = 'hide'
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions();

  // Si no hay permisos requeridos, mostrar siempre
  if (!permission && permissions.length === 0) {
    return <>{children}</>;
  }

  let hasAccess = false;

  if (permission) {
    hasAccess = hasPermission(permission);
  } else if (permissions.length > 0) {
    hasAccess = requireAll 
      ? hasAllPermissions(permissions)
      : hasAnyPermission(permissions);
  }

  // Si no tiene acceso, mostrar fallback o nada
  if (!hasAccess) {
    return <>{fallback}</>;
  }

  // Si tiene acceso, mostrar el contenido
  return <>{children}</>;
};

export default PermissionGate;
